import Button from "@mui/material/Button";
import React from "react";

export const AddButton = ({ handleClick, mobile }) => {
  return (
    <Button
      onClick={handleClick}
      variant="contained"
      sx={{
        backgroundColor: "#dddddd",
        color: "#555555",
        textTransform: "none",
        padding: "2px",
        width: "80%",
        height: mobile ? "26px" : "36px",
        margin: "4px 0",
        "&:hover": {
          backgroundColor: "#cccccc",
          boxShadow: "none",
        },
        "&:active": {
          backgroundColor: "#aaaaaa",
          boxShadow: "none",
        },
        boxShadow: "none",
        fontFamily: "proxima-nova, sans-serif",
        fontSize: mobile ? 12 : 18,
      }}
    >
      $ Add
    </Button>
  );
};
